import script from "./BulkOperationListElement.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkOperationListElement.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__